(() => {
  'use strict';

  const selectors = [
    '.section-content-wrapper > .group-block',
    '.section-content-wrapper > .text-block',
    '.section-content-wrapper > .image-block',
    '.collection-links__link',
    '.collection-links__images'
  ];
  const excluded = '.hero, .resource-list, .resource-list__carousel, .okeReviews, .hooper, quick-add-modal';
  let observer;

  function init(root = document) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)) return;

    const activeSelectors = [...selectors];
    if (document.querySelector('main')?.dataset?.template?.includes('collection')) {
      activeSelectors.push('.product-grid__card');
    }

    const candidates = [...root.querySelectorAll(activeSelectors.join(','))].filter(el =>
      !el.classList.contains('scroll-animate') &&
      !el.classList.contains('is-revealed') &&
      !el.closest(excluded)
    );
    const belowViewport = candidates.filter(el => el.getBoundingClientRect().top >= window.innerHeight);

    if (!belowViewport.length) return;
    observer ??= new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    for (const el of belowViewport) {
      el.classList.add('scroll-animate');
      observer.observe(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
